export function normalizeToastText(text) {
  return String(text || "")
    .trim()
    .replace(/\s+/g, " ");
}

export function toastIdFromText(prefix, text) {
  const normalizedText = normalizeToastText(text);

  return `${prefix}-${normalizedText}`;
}

export function toastTextWithCount(text, count) {
  const normalizedText = normalizeToastText(text);

  return count > 1 ? `${normalizedText} (x${count})` : normalizedText;
}
